import { render, staticRenderFns } from "./ViewDetailsModal.vue?vue&type=template&id=779d4595&scoped=true&"
import script from "./ViewDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ViewDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetailsModal.vue?vue&type=style&index=0&id=779d4595&prod&lang=scss&"
import style1 from "./ViewDetailsModal.vue?vue&type=style&index=1&id=779d4595&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779d4595",
  null
  
)

export default component.exports